







import Vue from 'vue'

export default Vue.extend({
  name: 'App'
  // components: {
  //   CoreLoadingOverlay: () => import('@/components/layout/core/CoreLoadingOverlay.vue')
  // }
})
